import React, { Component } from 'react';
import { Container } from 'flux/utils';
import PropTypes from 'prop-types';

import { Card, CardActions, CardText, CardTitle } from 'material-ui/Card';
import { discardCompliance, editCompliance, saveAndDiscardCompliance } from '../../actions/ComplianceActionCreator';
import ComplianceForm from './ComplianceForm';
import ComplianceStore from '../../stores/ComplianceStore';
import DetailView from '../Common/DetailView';
import FlatButton from 'material-ui/FlatButton';
import { browserHistory } from 'react-router';

class ComplianceEdit extends Component {

    componentDidMount() {
        editCompliance(this.props.id);
    }

    render() {
        const { draft } = this.state;
        if (!draft) { return <DetailView/>; }
        return (
            <DetailView>
                <Card className="cent-card">
                    <CardTitle title="Edit compliance" />
                    <CardText className="cent-card-text cent-flex-row">
                        <ComplianceForm draft={draft} />
                    </CardText>
                    <CardActions className="cent-card-actions">
                        <FlatButton label="Save" onTouchTap={() => { saveAndDiscardCompliance().then(() => browserHistory.goBack()); }} primary={true} />
                        <FlatButton label="Cancel" onTouchTap={() => { discardCompliance(); browserHistory.goBack(); }} />
                    </CardActions>
                </Card>
            </DetailView>
        );
    }
}

ComplianceEdit.propTypes = {
    id: PropTypes.number.isRequired,
};

ComplianceEdit.defaultProps = {

};


ComplianceEdit.getStores = () => ([ComplianceStore]);
ComplianceEdit.calculateState = () => ({
    draft: ComplianceStore.getDraft()
});

export default Container.create(ComplianceEdit);
